import React from "react";
import { Box, Chip, Select, MenuItem, Tooltip } from "@mui/material";
import { problemKeys } from "app/utils/constants/problem";
import { OPERATOR_LABELS } from "app/utils/constants/constants";

const KeyOperatorChips = ({
  keysWithOperators,
  editingKey,
  onDeleteKey,
  onOperatorChange,
  onEditFilter,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        marginX: 2,
        ...(keysWithOperators.length > 0 && { mb: 2 }),
      }}
    >
      <Box
        sx={{ display: "flex", flexWrap: "wrap", gap: 1, alignItems: "center" }}
      >
        {keysWithOperators.map(({ key, operator, searchTerm }, index) => (
          <Box
            key={index}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              "& .MuiOutlinedInput-root": { borderRadius: "16px" },
            }}
          >
            <Tooltip
              title={`${problemKeys[key]}.${OPERATOR_LABELS[operator]}=${searchTerm}`}
              placement="top"
              arrow
            >
              <Chip
                label={
                  searchTerm
                    ? `${problemKeys[key]}.${OPERATOR_LABELS[operator]}=${searchTerm}`
                    : `${problemKeys[key]}.${OPERATOR_LABELS[operator]}`
                }
                onDelete={() => onDeleteKey(key)}
                onClick={() => onEditFilter(key, searchTerm || "")}
                sx={{
                  backgroundColor: editingKey === key ? "#ff9800" : "#f39c12",
                  color: "white",
                  maxWidth: "150px",
                }}
                size="small"
              />
            </Tooltip>
            <Select
              value={operator}
              onChange={(e) => onOperatorChange(key, e.target.value)}
              size="small"
              sx={{ height: "24px", fontSize: "0.75rem", maxWidth: "150px" }}
            >
              {Object.entries(OPERATOR_LABELS).map(([opKey, opValue]) => (
                <MenuItem key={opKey} value={opKey}>
                  {opValue}
                </MenuItem>
              ))}
            </Select>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default KeyOperatorChips;
